<app-floorplan-product-menu
  [title]="tooltipTextSignalElements"
  [hasConfigurations]="signalElements.length > 0"
  [visible]="floorplan.floorplanState.signalElementsVisible"
  [locked]="floorplan.floorplanState.signalElementsLocked"
  [itemTextVisible]="floorplan.floorplanState.signalElementsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.signalElementsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.signalElementsLocked = $event"
  (itemTextVisibilityUpdate)="updateSignalElementsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="signal-element"
>
  @for (signalElement of signalElements; track signalElement) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="signalElement"
        [numberOfFloorplanItems]="floorplan.countPlacedSignalElements(signalElement)"
        (add)="addSignalElement(signalElement)"
        (delete)="deleteSignalElement(signalElement)"
        (dragStart)="drag(signalElement)"
        editPath="signal-element"
        imageUrl="./assets/icons-blue/leuchttransparent_blau.svg"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
